/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from 'react';
import { Formik, FormikHelpers } from 'formik';

import { useHistory } from 'react-router-dom';
import { LuCalendarRange, LuFileText, LuUsers } from 'react-icons/lu';

import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { InputTextarea } from 'primereact/inputtextarea';
import { ListBox } from 'primereact/listbox';

import api from '../../../../services/api';
import useResponsaveis from '../../../../hooks/useResponsaveis';

import { useToast } from '../../../../hooks/toast';

import {
  DateFilter,
  Field,
  FilterStyles,
  Section,
} from '../../../../components/FilterKit';

interface SearchData {
  proc_cod_cliente: number;
  sector: string | string[];
  inCharge: string;
  referenceId: number;
  description: string;
  proc_data_ajuiz_inicio: Date;
  proc_data_ajuiz_final: Date;
}

const SearchHourBilled:React.FC = () => {
  const { addToast } = useToast();
  const history = useHistory();

  const [customerId, setCustomerId] = useState('0');
  const [referenceId, setReferenceId] = useState('');
  const [description, setDescription] = useState('');

  const [
    initialRegistrationDate, setInitialRegistrationDate,
  ] = useState<string | Date | Date[] | null>(null);
  const [
    finalRegistrationDate, setFinalRegistrationDate,
  ] = useState<string | Date | Date[] | null>(null);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [customersOptions, setCustomersOptions] = useState([{}]);
  const [sectorOptions, setSectorOptions] = useState([{}]);
  const [referenceOptions, setReferenceOptions] = useState([{}]);
  const [sectorValue, setSectorValue] = useState(['all']);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [inCharge, setInCharge] = useState<any>('global|0');
  const [dateFilterType, setDateFilterType] = useState('data');

  const validationSchema = null;

  useEffect(() => {
    (async () => {
      await api.get('/lawsuits/references/show/all').then((response) => {
        referenceOptions.push({
          name: 'Padrão',
          value: 0,
        });
        response.data.map((reference: {
          horas_referencia_id: number,
          horas_referencia_nome:string}) => (
          referenceOptions.push({
            name: reference.horas_referencia_nome,
            value: reference.horas_referencia_id,
          })
        ));
      });
      referenceOptions.splice(0, 1);
      setReferenceOptions(referenceOptions);
    })();
  }, [referenceOptions]);

  useEffect(() => {
    (async () => {
      await api.get('customers/show/all').then((response) => {
        response.data.map((customer:
        {
          cliente_id: number,
          cliente_nome:string
        }) => (
          customersOptions.push({
            name: customer.cliente_nome,
            value: customer.cliente_id,
          })
        ));
      });
      customersOptions.splice(0, 1);
      setCustomersOptions(customersOptions);
    })();
  }, [customersOptions]);

  useEffect(() => {
    (async () => {
      const sectorArray = [{ name: '', value: '' }];

      await api.get('/management/attorneys/show/inchargelawsuits/attorneys').then((response) => {
        if (response.data.length > 0) {
          sectorArray.push({
            name: 'Todos',
            value: 'all',
          });
          response.data.map((sector: {
            setor_adv: string
          }) => (
            sectorArray.push({
              name: sector.setor_adv,
              value: sector.setor_adv,
            })
          ));
        }
      });

      await api.get('/management/attorneys/show/inchargelawsuits/others').then((response) => {
        if (response.data.length > 0) {
          response.data.forEach((sector: {
            setor_adm: string
          }) => {
            // if (sectorOptions.indexOf(sector.setor_adm) === -1) {
            sectorArray.push({
              name: sector.setor_adm,
              value: sector.setor_adm,
            });
            // }
          });
        }
      });

      sectorArray.splice(0, 1);
      setSectorOptions(sectorArray);
    })();
  }, []);

    const { inChargeOptions, filterAttorneysInCharge } = useResponsaveis({
    urlAdvogados: `management/attorneys/show/all/active/lawsuit/${sessionStorage.getItem('categoria')}/${sessionStorage.getItem('setor')}`,
    urlAssistentes: 'management/assistants/show/all/active',
    todos: {
        label: 'Todos',
        items: [
          { label: 'Todos', value: 'global|0' },
          { label: 'Todos - exceto estagiários', value: 'global|99997' },
          { label: 'Todos - exceto assistentes', value: 'global|99998' },
          { label: 'Todos - exceto estagiários e assistentes', value: 'global|99999' },
        ],
      },
  });

  const handleOnSubmit = async (
    values: SearchData,
    { setSubmitting }: FormikHelpers<SearchData>,
  ) => {
    try {
      // const access = JSON.parse(sessionStorage.getItem('@Jurisnet:access') || '{}');
      const access = JSON.parse(localStorage.getItem('@Jurisnet:access') || '{}');

      let menu = '';
      if (access) {
        menu = access.menu;
      }
      const searchFormData = {
        proc_cod_cliente: customerId,
        sector: sectorValue,
        inCharge,
        referenceId,
        description,
        proc_data_ajuiz_inicio: initialRegistrationDate,
        proc_data_ajuiz_final: finalRegistrationDate,
        dateFilterType,
        menu,
      };

      localStorage.removeItem('@Jurisnet:selectedhour');

      history.push({
        pathname: '/report/hour/billed',
        state: searchFormData,
      });

      setSubmitting(false);
    } catch (error) {
      addToast({
        type: 'error',
        title: 'Ocorreu um problema',
        description:
              'Tente repetir a pesquisa ou contate o administrador.',
      });
    }
  };

  const handleClear = () => {
    setCustomerId('0');
    setReferenceId('');
    setDescription('');
    setInitialRegistrationDate(null);
    setFinalRegistrationDate(null);
    setDateFilterType('data');
    setInCharge('global|0');
    setSectorValue(['all']);
    if (sectorValue.length !== 1 || sectorValue[0] !== 'all') {
      filterAttorneysInCharge('all');
    }
  };

  const initialValues: SearchData = {
    proc_cod_cliente: 0,
    sector: ['all'],
    inCharge: 'global|0',
    referenceId: 0,
    description: '',
    proc_data_ajuiz_inicio: new Date(),
    proc_data_ajuiz_final: new Date(),
  };

  return (
    <FilterStyles>
      <div className="card search-card">
        <header className="search-title">
          <h3>Relatório de Horas faturadas - Modelo VI</h3>
          <span className="search-hint">
            Preencha só o que precisar para filtrar as horas faturadas.
          </span>
        </header>

        <Formik
          onSubmit={handleOnSubmit}
          validationSchema={validationSchema}
          enableReinitialize
          initialValues={initialValues}
        >
          {({
            isSubmitting,
            handleSubmit,
            handleReset,
          }) => (
            <form onSubmit={handleSubmit}>
              <div className="search-grid">
                <div className="search-col">
                  <Section icon={<LuUsers />} title="Cliente e responsável">
                    <div className="row r2">
                      <Field id="proc_cliente" label="Cliente">
                        <Dropdown
                          id="proc_cliente"
                          name="proc_cliente"
                          options={customersOptions}
                          onChange={(e) => setCustomerId(e.target.value)}
                          value={customerId}
                          className="inputfield w-full"
                          optionLabel="name"
                          optionValue="value"
                          filter
                          resetFilterOnHide
                          filterBy="name"
                          placeholder="Selecione uma opção"
                          emptyFilterMessage="Nenhum registro encontrado"
                        />
                      </Field>
                      <Field id="inChargeDropDown" label="Responsável">
                        <Dropdown
                          id="inChargeDropDown"
                          name="inChargeDropDown"
                          className="inputfield w-full"
                          value={inCharge}
                          options={inChargeOptions || {}}
                          // eslint-disable-next-line @typescript-eslint/no-explicit-any
                          onChange={(e: {value: any}) => setInCharge(e.value)}
                          optionLabel="label"
                          optionGroupLabel="label"
                          optionGroupChildren="items"
                        />
                      </Field>
                    </div>
                    <Field id="sector" label="Setor">
                      <ListBox
                        id="sector"
                        name="sector"
                        options={sectorOptions}
                        onChange={(e) => {
                          setSectorValue(e.target.value);
                          filterAttorneysInCharge(e.target.value);
                        }}
                        value={sectorValue}
                        className="inputfield w-full"
                        optionLabel="name"
                        optionValue="value"
                        multiple
                        filter
                        filterBy="name"
                        listStyle={{ maxHeight: '160px' }}
                      />
                    </Field>
                  </Section>
                </div>

                <div className="search-col">
                  <Section icon={<LuFileText />} title="Referência e descrição">
                    <Field id="proc_cod_adv_resp" label="Referência">
                      <Dropdown
                        id="proc_cod_adv_resp"
                        name="proc_cod_adv_resp"
                        options={referenceOptions}
                        onChange={(e) => setReferenceId(e.target.value)}
                        value={referenceId}
                        className="inputfield w-full"
                        optionLabel="name"
                        optionValue="value"
                        filter
                        resetFilterOnHide
                        filterBy="name"
                        placeholder="Selecione uma opção"
                        emptyFilterMessage="Nenhum registro encontrado"
                      />
                    </Field>
                    <Field id="description" label="Descrição">
                      <InputTextarea
                        id="description"
                        name="description"
                        className="inputfield w-full"
                        value={description || ''}
                        onChange={(e) => setDescription(e.target.value)}
                        rows={4}
                        cols={30}
                      />
                    </Field>
                  </Section>

                  <Section icon={<LuCalendarRange />} title="Período">
                    <DateFilter
                      id="data_registro"
                      label="Data de registro"
                      withMode
                      value={{
                        mode: dateFilterType === 'periodo' ? 'periodo' : 'data',
                        start: initialRegistrationDate instanceof Date
                          ? initialRegistrationDate : null,
                        end: finalRegistrationDate instanceof Date
                          ? finalRegistrationDate : null,
                      }}
                      onChange={(next) => {
                        setDateFilterType(next.mode);
                        setInitialRegistrationDate(next.start);
                        setFinalRegistrationDate(next.end);
                      }}
                    />
                  </Section>
                </div>
              </div>

              <footer className="search-actions">
                <div className="buttons">
                  <Button
                    icon="pi pi-check"
                    iconPos="left"
                    label="Pesquisar processos"
                    className="p-mr-2"
                    type="submit"
                    disabled={isSubmitting}
                  />
                  <Button
                    icon="pi pi-undo"
                    iconPos="left"
                    label="Limpar campos"
                    className="p-button-secondary p-mr-2"
                    type="button"
                    onClick={() => {
                      handleClear();
                      handleReset();
                    }}
                  />
                </div>
              </footer>
            </form>
          )}
        </Formik>
      </div>
    </FilterStyles>
  );
};

export default SearchHourBilled;
